export default "/_next/static/media/Tradly MEta image.7eb3a4ee3f9720a783204c7561fedb96.png";